import React from 'react'
import { useTheme } from '@mui/material'
import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid2'
import defaultTexts from '../../../texts/texts'
import { capitalizeFirstLetter } from '../../_common/_helpers/string'
import CustomCheckboxField from '../../_common/_form_fields/CustomCheckboxField'

const GeneralConfigView = (props) => {
  const { accountConfigs } = props
  const theme = useTheme()

  const keyLgStyle = {
    color: theme.palette.oxfordBlue,
    fontSize: '16px',
    fontWeight: '500',
    marginBottom: '20px',
  }

  const keySmStyle = {
    color: theme.palette.vodka,
    fontSize: '16px',
    fontWeight: '500',
  }

  const valueSmStyle = {
    color: theme.palette.oxfordBlue,
    fontSize: '16px',
    fontWeight: '400',
  }

  const checkboxStyle = {
    color: theme.palette.violetsAreBlue,

    '&.Mui-checked': {
      color: theme.palette.violetsAreBlue,
    },

    '& .MuiSvgIcon-root': {
      fontSize: 24,
    },
  }

  const checkboxLabelStyle = {
    color: theme.palette.oxfordBlue,
    fontSize: '16px',
  }
  
  return (
    <>
      {
        accountConfigs &&
        <Grid container spacing={4}>
          <Grid size={{ xs: 12, lg: 6, xl: 5 }}>

            <Box sx={keyLgStyle}>
              <Box component='span'>{defaultTexts.billingService}: </Box>
              <Box
                component='span'
                sx={{
                  color: accountConfigs.status === 'active' ? theme.palette.greenSheen : theme.palette.coralRed
                }}
              >
                { accountConfigs.status === 'active' ? defaultTexts.enabled : defaultTexts.disbaled }
              </Box>
            </Box>

            <Box sx={{ marginBottom: '20px' }}>
              <Box component='span' sx={keySmStyle}>{defaultTexts.defaultAccountType}: </Box>
              <Box component='span' sx={valueSmStyle}>{capitalizeFirstLetter(accountConfigs.default_billing_type)}</Box>
            </Box>

            <Box sx={{ marginBottom: '20px' }}>
              <Box component='span' sx={keySmStyle}>{defaultTexts.postpaidInvoiceType}: </Box>
              <Box component='span' sx={valueSmStyle}>{capitalizeFirstLetter(accountConfigs.postpaid_invoice)}</Box>
            </Box>

            <Box sx={{ marginBottom: '20px' }}>
              <CustomCheckboxField
                label={defaultTexts.useISender}
                checked={accountConfigs.invoice_manager ? true : false}
                handleChange={() => {}}
                sx={checkboxStyle}
                sxLabel={checkboxLabelStyle}
              />
            </Box>

            <Box sx={{ marginBottom: '20px' }}>
              <Box component='span' sx={keySmStyle}>{defaultTexts.postpaidInvoicePayPeriod}: </Box>
              <Box component='span' sx={valueSmStyle}>{accountConfigs.postpaid_invoice_pay_period}</Box>
            </Box>

            <Box sx={{ marginBottom: '20px' }}>
              <CustomCheckboxField
                label={defaultTexts.allowPublicPriceCalculator}
                checked={accountConfigs.allow_public_price_calculator ? true : false}
                handleChange={() => {}}
                sx={checkboxStyle}
                sxLabel={checkboxLabelStyle}
              />
            </Box>

          </Grid>
          <Grid size={{ xs: 12, lg: 6, xl: 7 }}>
            
            <Box sx={{ marginBottom: '20px' }}>
              <Box component='span' sx={keySmStyle}>{defaultTexts.currency}: </Box>
              <Box component='span' sx={valueSmStyle}>{accountConfigs.currency.name.toUpperCase()}</Box>
            </Box>            

            <Box sx={{ marginBottom: '20px' }}>
              <CustomCheckboxField
                label={defaultTexts.enableVatTax}
                checked={accountConfigs.use_vat_tax ? true : false}
                handleChange={() => {}}
                sx={checkboxStyle}
                sxLabel={checkboxLabelStyle}
              />
            </Box>

            {
              accountConfigs.use_vat_tax &&
              <>
                <Box sx={{ marginBottom: '20px' }}>
                  <CustomCheckboxField
                    label={defaultTexts.pricesIncludeVatTax}
                    checked={accountConfigs.price_includes_vat ? true : false}
                    handleChange={() => {}}
                    sx={checkboxStyle}
                    sxLabel={checkboxLabelStyle}
                  />
                </Box>

                <Box sx={{ marginBottom: '20px' }}>
                  <Box component='span' sx={keySmStyle}>{defaultTexts.vatTaxPerc}: </Box>
                  <Box component='span' sx={valueSmStyle}>{accountConfigs.vat}</Box>
                </Box>
              </>
            }

          </Grid>
        </Grid>
      }
    </>
  )
}

export default GeneralConfigView